
import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3ExposesSyndicationCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>
          A feed (called an Atom or RSS feed) can be read by other websites, software and search engines to easily find new content and read it. It's structured in such a way that makes it easier to understand for them than a webpage.
        </p>
        <hr />
        <h2>How it's used</h2>
        <ul>
          <li>Search engines use feeds to quickly identify new content</li>
          <li>It can help frequently updated information like blogs to be indexed faster by search engines</li>
          <li>Plug in SEO uses the feed to analyse your blog posts for SEO best practices</li>
          <li>Feeds also allow sharing and news readers to access your content easier, leading to wider sharing of your content</li>
      </ul>
      <hr />
      <h2>Best practice</h2>
      <ul>
        <li>Expose a feed for your blog and news content</li>
      </ul>
      <hr />
      <h2>Fix this yourself</h2>
      <p>
        Shopify stores expose a blog feed out-of-the-box. First speak with your theme developer to see why the feed isn't being exposed. Then you might have to contact Shopify support to diagnose.
      </p>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3ExposesSyndicationCheck.js